import { Outlet } from "react-router-dom";
import { Fragment } from 'react';
import HeaderSection from "../Headers/HeaderSection";
import styled from "styled-components";

import FooterSection from "../Footers/FooterSection.js";

const Container = styled.div`
  max-width: 100%;
  margin: 0 auto;
  display: flex;    
  flex-direction: column;
  gap: 3.2rem;
`;


const PublicLayout = (props) => {
    return (
        <Fragment>
            <HeaderSection />
            <Container>
                <div>
                    <Outlet />
                </div>
            </Container>
            <FooterSection />
        </Fragment>
    );
};
export default PublicLayout;
